import {
  Button,
  Chip,
  CircularProgress,
  Container,
  Divider,
  List,
  ListItem,
  Stack,
  Typography,
  Box,
  useMediaQuery
} from "@mui/material";
import React, { useState } from "react";
import Header from "../../components/header/header";
import EmbeddableCardDetails from "../embeddablePaymentInformation/embeddableCardDetails";
import Invoice from "../../components/paymentDetails/invoice";
import { grey } from "@mui/material/colors";
import { brandGray, brandLight, brandLightGreen } from "../../constants";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router";
const EmbeddablePaymentComponent = () => {
  const { authtoken } = useParams();
  const isAuthTokenFromURLPresent = authtoken && 
  (authtoken != null || authtoken != undefined);
  if(isAuthTokenFromURLPresent){
    localStorage.setItem("auth_token", authtoken);
  }
  const theme = useTheme();


  return (
      <Container
        sx={{ marginY: "35px" }}
        maxWidth="lg"
        disableGutters={useMediaQuery(theme.breakpoints.up("lg"))}
      >
          <Box
            sx={{
              paddingY: 2,
              paddingX: 4,
              borderRadius: "1rem",
              backgroundColor: brandLight,
              borderRadius: "1rem 1rem 1rem 1rem",
              textAlign: "center",
            }}
          >
            <EmbeddableCardDetails />
          </Box>
      </Container>
  );
};
export default EmbeddablePaymentComponent;
